<template>
  <div>
    <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form-style"
      @submit.prevent="handleLogin">
      <el-form-item label="密码:" prop="keyPassword">
        <el-input v-model="loginForm.keyPassword" type="password" auto-complete="off" placeholder="请输入密码"
          @keydown.enter.prevent="handleLogin" @input="handleInput($event)">
        </el-input>
      </el-form-item>
    </el-form>
    <div class="footer-button">
      <el-button :loading="loading" type="primary" style="
            width: 100%;
            height: 35px;
            background-color: #4a8ddf;
            border: 1px solid #4a8ddf;
          " @click.native.prevent="handleLogin" :disabled="!isReady || loading">
        <span v-if="loading">登 录 中...</span>
        <span v-else-if="!isReady">准备中...</span>
        <span v-else>登 录</span>
      </el-button>
      <div class="usb-key-driver-hint">
        如果您未安装USB-KEY驱动，请先点击<a class="key-style" @click="showKeysDialog">下载驱动</a>
      </div>
    </div>

    <KeysDialog ref="keysDialog" />
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import { getInfo } from "@/api/login";
import useUserStore from "@/store/modules/user";
import KeysDialog from "./keysDialog";
import AtlCtrlForET99 from "@/utils/et99/index.js";
import ht from "@/utils/ht";
export default {
  name: "KeyLogin",
  components: {
    KeysDialog,
  },
  data() {
    const router = useRouter();

    return {
      loginRules: {
        keyPassword: [
          { required: true, message: "请输入KEY密码", trigger: "blur" },
        ],
      },
      loginForm: {
        keyPassword: "",
        sn: "",
        keyType: "",
      },
      et99: {},
      ws: true,
      userInfo: {},
      loading: false,
      router,
      formLoading: true,
      isReady: false, // 标记是否准备就绪（WebSocket连接建立且获取到key序列号）
      keySn: "", // 存储key序列号
    };
  },
  mounted() {
    let obj = document.getElementsByClassName("object");
    let flag = false;
    for (let i = 0; i < obj.length; i++) {
      if (obj[i].getAttribute(id) == "et99") {
        return (flag = true);
      }
    }

    if (!flag) {
      ht.domAppend(document.getElementsByTagName("body")[0]);
    }

    let _this = this;

    _this.et99 = new AtlCtrlForET99("{7356CC90-5909-4f44-A07E-329D0BD3FF81}");
    _this.et99.initWS();

    // 等待WebSocket连接建立并获取key序列号
    _this.initKeyLogin();

    // setTimeout(() => {
    //   _this.formLoading = false;
    // }, 500);
  },

  methods: {
    // 初始化Key登录准备工作
    initKeyLogin() {
      let _this = this;

      setTimeout(function () {
        if (!_this.ws) {
          if (0 == _this.et99.ET99_OpenToken("ffc5eb78", 1)) {
            _this.loginForm.keyType = "et99";
            // 获取序列号
            _this.getSN();
          }
        } else {
          _this.et99.ET99_OpenToken(function (ores, orep) {
            if (ores && 0 == orep) {
              _this.keystatus = true;
              // 获取序列号
              _this.getSN();
            } else {
              // 连接失败，延迟重试
              setTimeout(() => {
                _this.initKeyLogin();
              }, 500);
            }
          });
        }
      }, 300);
    },

    // 获取Key序列号
    getSN() {
      let _this = this;
      _this.et99.ET99_GetSN(function (sres, srep) {
        if (sres) {
          if (srep != "0000000000000000") {
            _this.keySn = srep;
            _this.loginForm.sn = srep;
            _this.loginForm.keyType = "et99";
            _this.isReady = true; // 准备就绪
          } else {
            // 未找到key，继续尝试
            setTimeout(() => {
              _this.getSN();
            }, 500);
          }
        } else {
          // 获取失败，延迟重试
          setTimeout(() => {
            _this.getSN();
          }, 500);
        }
      });
    },
    handleInput(value) {
      // 禁止输入空格
      const filteredValue = value.replace(/\s/g, '');
      this.loginForm.keyPassword = filteredValue;
    },

    showKeysDialog() {
      this.$refs.keysDialog.showDialog();
    },

    // KEY登录
    handleLogin() {
      let _this = this;

      // 检查是否准备就绪
      if (!this.isReady) {
        this.$message.warning("正在准备中，请稍候...");
        return;
      }

      if (this.loginForm.keyPassword != "") {
        const loading = this.$loading({
          lock: true,
          text: "登录中，请稍侯.....",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)",
        });

        // 使用预获取的序列号
        const sn = this.keySn;

        if (!sn || sn === "0000000000000000") {
          loading.close();
          _this.$message.warning(
            "未找到Key设备，请确保加密狗是否正常运行、驱动是否安装正确！",
          );
          return;
        }

        const { keyPassword } = _this.loginForm;

        // 过滤掉空格
        const filteredKeyPassword = keyPassword.replace(/\s/g, '');

        const provinceInfo = JSON.parse(
          sessionStorage.getItem("provinceInfo"),
        );

        // 获取 provinceId，优先从 sessionStorage，其次从 URL
        let provinceId = provinceInfo?.areaId;

        if (!provinceId) {
          // 从 URL 中提取省份代码
          const url = window.location.pathname;
          const linkCode = url.substring(url.lastIndexOf('/') + 1).toLowerCase();

          // 省份代码到 provinceId 的映射
          const urlData = {
            "bj": 2,
            "tj": 21,
            "heb": 28,
            "sx": 241,
            "sh": 867,
            "nm": 383,
            "ln": 506,
            "jl": 635,
            "hl": 713,
            "zj": 1018,
            "ah": 1131,
            "fj": 1269,
            "jx": 1373,
            "sd": 1496,
            "hen": 1671,
            "hb": 1866,
            "hn": 1996,
            "gd": 2146,
            "gx": 2308,
            "hi": 2446,
            "sc": 2516,
            "gz": 2737,
            "yn": 2840,
            "xz": 2994,
            "sn": 3076,
            "gs": 3204,
            "qh": 3317,
            "nx": 3370,
            "xj": 3403,
            "xjscjsbt": 3685
          };

          provinceId = urlData[linkCode];
        }

        const userStore = useUserStore();
        const params = {
          accessKey: sn,
          loginType: "key",
          provinceId: provinceId,
          secretKey: filteredKeyPassword,
          verificationCodeInfo: {
            checkCode: "",
            yzmCode: "",
          },
        };
        userStore
          .login(params, "keyLogin")
          .then((rs) => {
            if (rs.success) {
              getInfo().then((res) => {
                console.log("res", res);
                if (res.success) {
                  userStore.setUserInfo(res.data);
                  sessionStorage.setItem(
                    "userInfo",
                    JSON.stringify(res.data),
                  );
                  if (res.data.isUniversalKey) {
                    _this.router.push("/keyList");
                  }
                } else {
                  _this.$modal.alert(res.message, true);
                }
              });
            } else {
              _this.$modal.alert(rs.message, true);
            }

            loading.close();
          })
          .catch((err) => {
            _this.$modal.alert(err.message, true);
            console.log("err", err);
            loading.close();
          });
      } else {
        this.$message({
          message: "请输入密码！",
          type: "error",
          duration: 1500,
        });
      }
    },
    //坚石诚信Key
    async ET99_Check() {
      let _this = this;
      await _this.et99.ET99_GetSN(function (sres, srep) {
        if (sres) {
          if (srep != "0000000000000000") {
            _this.loginForm.sn = srep;
            _this.loginForm.keyType = "et99";
            return true;
          }
        }
      });
      return false;
    },
  },
};
</script>

<style lang="scss" scoped>
.key-style {
  color: red;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.login-code {
  width: 33%;
  height: 38px;
  float: right;

  img {
    cursor: pointer;
    vertical-align: middle;
  }
}

.login-code-img {
  height: 38px;
}

.login-form-style {
  position: relative;
  width: 100%;

  :deep .el-form-item__label {
    line-height: 38px !important;
  }

  .el-input {
    height: 38px;

    input {
      height: 38px;
    }
  }

  .input-icon {
    height: 39px;
    width: 14px;
    margin-left: 2px;
  }
}

.footer-button {
  text-align: center;

  .usb-key-driver-hint {
    margin-top: 20px;
    font-size: 13px;
    line-height: 1.5;
  }
}
</style>
